"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFillHandleStatus = exports.setFieldRanges = exports.clearSelection = exports.clearSelectionButKeepCheckedRecord = exports.setRecordRange = exports.setActiveCell = exports.setSelection = void 0;
const model_1 = require("../../../../../../model");
const store_1 = require("../../../../../../exports/store");
const action_constants_1 = require("../../../../../../modules/shared/store/action_constants");
/**
 * set the selection area
 * @param ranges
 * @returns
 */
const setSelection = (ranges) => (dispatch, getState) => {
    const state = getState();
    const datasheetId = state.pageParams.datasheetId;
    const selectionState = store_1.Selectors.getDatasheetClient(state).selection;
    const payload = Array.isArray(ranges) ? ranges : [ranges];
    const range = payload[0];
    if (!selectionState || !selectionState.ranges || !selectionState.activeCell) {
        return dispatch({
            type: action_constants_1.SET_SELECTION,
            datasheetId,
            payload: {
                activeCell: range.start,
                ranges: payload,
            },
        });
    }
    return dispatch({
        type: action_constants_1.SET_SELECTION,
        datasheetId,
        payload: {
            ranges: payload,
        },
    });
};
exports.setSelection = setSelection;
/**
 * set the active cell
 * @param datasheetId
 * @param cell
 * @returns
 */
const setActiveCell = (datasheetId, cell) => {
    const payload = cell;
    return {
        type: action_constants_1.SET_ACTIVE_CELL,
        datasheetId,
        payload: {
            // when activate cell, selection area equals the the vector of active cell itself
            ranges: [{ start: cell, end: cell }],
            activeCell: payload,
        },
    };
};
exports.setActiveCell = setActiveCell;
/**
 * set the records being selected
 *
 * @param datasheetId
 * @param recordRange
 * @returns
 */
const setRecordRange = (datasheetId, recordRange) => {
    return {
        type: action_constants_1.SET_RECORD_SELECTION,
        datasheetId,
        payload: recordRange,
    };
};
exports.setRecordRange = setRecordRange;
/**
 * remain checked records, but clear active cell and continuous selection area data.
 * @param datasheetId
 * @returns
 */
const clearSelectionButKeepCheckedRecord = (datasheetId) => {
    return {
        type: action_constants_1.CLEAR_SELECTION_BUT_KEEP_CHECKED_RECORD,
        datasheetId,
    };
};
exports.clearSelectionButKeepCheckedRecord = clearSelectionButKeepCheckedRecord;
/**
 * clear the data in selection area
 *
 * @param datasheetId
 * @returns
 */
const clearSelection = (datasheetId) => {
    return {
        type: action_constants_1.CLEAR_SELECTION,
        datasheetId,
    };
};
exports.clearSelection = clearSelection;
/**
 * set current selected columns
 *
 * @param datasheetId
 * @param payload
 * @returns
 */
const setFieldRanges = (datasheetId, payload) => {
    return {
        type: action_constants_1.SET_FIELD_RANGES,
        datasheetId,
        payload,
    };
};
exports.setFieldRanges = setFieldRanges;
/**
 * set the Fill Handle active status
 *
 * @param payload
 * @returns
 */
const setFillHandleStatus = (payload) => (dispatch, getState) => {
    const state = getState();
    const datasheetId = state.pageParams.datasheetId;
    const selection = store_1.Selectors.getSelection(state);
    const fillHandleStatus = store_1.Selectors.getFillHandleStatus(state);
    if (!selection)
        return;
    if (!selection.ranges)
        return;
    const selectionRange = selection.ranges[0];
    if (!payload.hoverCell) {
        return dispatch({
            type: action_constants_1.SET_FILL_HANDLE_STATUS,
            datasheetId,
            payload: {
                fillHandleStatus: payload,
            },
        });
    }
    // after click the fill handle, mouse can drag anywhere, hover on any cell
    // calculate the fill direction according to `hoverCell`, and then fix the selection area.
    const direction = model_1.Range.bindModel(selectionRange).getDirection(state, payload.hoverCell);
    if (!direction)
        return;
    const isFillHandleActive = Boolean(fillHandleStatus && fillHandleStatus.isActive);
    const fillRange = model_1.Range.bindModel(selectionRange).getFillRange(state, payload.hoverCell, direction);
    if (!fillRange)
        return;
    if (!isFillHandleActive)
        return;
    return dispatch({
        type: action_constants_1.SET_FILL_HANDLE_STATUS,
        datasheetId,
        payload: {
            fillHandleStatus: Object.assign(Object.assign({}, payload), { fillRange,
                direction }),
        },
    });
};
exports.setFillHandleStatus = setFillHandleStatus;
//# sourceMappingURL=selection.js.map